__turbopack_context__.v({
  "btn": "TicketPopUp-module-scss-module__u8urca__btn",
  "close": "TicketPopUp-module-scss-module__u8urca__close",
  "modal": "TicketPopUp-module-scss-module__u8urca__modal",
  "modalForm": "TicketPopUp-module-scss-module__u8urca__modalForm",
  "modalInfo": "TicketPopUp-module-scss-module__u8urca__modalInfo",
  "modalLink": "TicketPopUp-module-scss-module__u8urca__modalLink",
  "open": "TicketPopUp-module-scss-module__u8urca__open",
  "popupBody": "TicketPopUp-module-scss-module__u8urca__popupBody",
  "selected": "TicketPopUp-module-scss-module__u8urca__selected",
  "toggle": "TicketPopUp-module-scss-module__u8urca__toggle",
  "visuallyHidden": "TicketPopUp-module-scss-module__u8urca__visuallyHidden",
});
